import React from 'react'
import styled from 'styled-components'

const Nav: React.FC = () => {
  return (
    <StyledNav>
      {/* <StyledLink
        target="_blank"
        href="#"
      >
        JuiceMaster Contract
      </StyledLink> */}
      {/*<StyledLink
        target="_blank"
        href="https://uniswap.info/pair/0xce84867c3c02b05dc570d0135103d3fb9cc19433"
      >
        SushiSwap SUSHI-ETH
      </StyledLink> */}
      {/* <StyledLink target="_blank" href="#">
        Discord
      </StyledLink> */}
      <StyledLink target="_blank" href="https://rentomania.online/">
        Rentomania Game
      </StyledLink>
      <StyledLink
        target="_blank"
        href="https://app.v4.testnet.pulsex.com/swap?inputCurrency=pls&outputCurrency=0xCe6E96c533CD352f2006Ce86D8D43AE8eCB6003A"
      >
        PulseX
      </StyledLink>
      <StyledLink target="_blank" href="https://twitter.com/RentomaniaGame">
        Twitter
      </StyledLink>
      <StyledLink target="_blank" href="https://t.me/RentomaniaGame">
        Telegram Channel
      </StyledLink>
      <StyledLink target="_blank" href="https://t.me/RentomaniaChat">
        Telegram Chat
      </StyledLink>
      {/* <StyledLink target="_blank" href="#">
        Medium
      </StyledLink> */}
    </StyledNav>
  )
}

const StyledNav = styled.nav`
  align-items: center;
  display: flex;
`

const StyledLink = styled.a`
  color: #fff;
  padding-left: ${(props) => props.theme.spacing[3]}px;
  padding-right: ${(props) => props.theme.spacing[3]}px;
  text-decoration: none;
  &:hover {
    color: ${(props) => props.theme.color.grey[500]};
  }
`

export default Nav
